import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'autoLink'
})
export class AutoLinkPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    const urlRegex = /((https?:\/\/|www\.)[^\s]+)/g;
    return value.replace(urlRegex, url => {
      const hyperlink = url.startsWith('http') ? url : `http://${url}`;
      return `<a href="${hyperlink}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  }
}
